import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapRelatedTopicsSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcaprelatedtopics: {
      group: 'inline',
      inline: true,
      content: 'madcaprelatedtopic*',
      atom: true,
      isLink: true,
      definingForContent: true,
      parseDOM: [{
        tag: 'MadCap\\:relatedTopics'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:relatedTopics',
      isTagNameBox: true,
      specContent: 'madcaprelatedtopic'
    },

    madcaprelatedtopic: {
      inline: true,
      attrs: {
        'src': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:relatedTopic',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['src']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      isVoid: true,
      tagName: 'MadCap:relatedTopic',
      specContext: 'madcaprelatedtopics'
    }
  } satisfies Record<string, NodeSpec>;
}
